import { Box } from '@mui/material';
import DataCard from 'components/data-card/data-card.component';
import { useSMSTotalsSearch } from 'pages/analytics/sms-reports/sms-reports-landing/sms-reports-search/sms-reports-search.hooks';
import { useTranslation } from 'react-i18next';

const AccountVerificationSummaryHeader = () => {
  const { t } = useTranslation();

  const { data, isFetching } = useSMSTotalsSearch('ACCOUNT_VERIFICATION');

  return (
    <Box
      display="grid"
      gridTemplateColumns={{ xs: 'repeat(1, 1fr)', lg: 'repeat(2, 1fr)' }}
      gap={2}
    >
      <DataCard
        title={t(
          'page.reportAndAnalytics.smsReports.sections.accountVerification.summaryHeader.accountVerificationSMSTotal.title',
        )}
        value={data?.smsTotal ?? 0}
        valueType="number"
        description={t(
          'page.reportAndAnalytics.smsReports.sections.accountVerification.summaryHeader.accountVerificationSMSTotal.description',
        )}
        loading={isFetching}
        data-testid="AccountVerificationSMSTotal.Card"
      />
      <DataCard
        title={t(
          'page.reportAndAnalytics.smsReports.sections.accountVerification.summaryHeader.accountVerificationSMSSegmentTotal.title',
        )}
        value={data?.segmentsTotal ?? 0}
        valueType="number"
        description={t(
          'page.reportAndAnalytics.smsReports.sections.accountVerification.summaryHeader.accountVerificationSMSSegmentTotal.description',
        )}
        loading={isFetching}
        data-testid="AccountVerificationSMSSegmentTotal.Card"
      />
    </Box>
  );
};
export default AccountVerificationSummaryHeader;
